import { onMounted, ref } from '@vue/composition-api'
import gql from 'graphql-tag'
import GET_CART_CONTENTS from '../graphql/supplyOrders.gql'

export default function useCartProducts(ctx) {
  const supplyOrders = ref([])
  const loading = ref(false)

  onMounted(async () => {
    await getCartProducts()
  })

  const getCartProducts = async () => {
    loading.value = true
    try {
      let res = await ctx.root.$apollo.query({
        fetchPolicy: 'network-only',
        query: GET_CART_CONTENTS,
        variables: { supplyOrderStatusId: 4 }
      })
      supplyOrders.value = res.data.supplyOrders.items
      loading.value = false
    } catch (e) {
      loading.value = false
      throw e
    }
  }

  const removeProduct = supplyOrderProductId => {
    return ctx.root.$apollo.mutate({
      client: 'second',
      mutation: gql`
        mutation removeSupplyOrderProduct($id: Int!) {
          deleteSupplyOrderProduct(supplyOrderProductId: $id)
        }
      `,
      variables: {
        id: +supplyOrderProductId
      }
    })
  }

  const deleteSupplyOrder = supplyOrderId => {
    ctx.root.$apollo
      .mutate({
        mutation: gql`
          mutation deleteSupplyOrder($supplyOrderId: Int!) {
            deleteSupplyOrder(supplyOrderId: $supplyOrderId)
          }
        `,
        variables: {
          supplyOrderId
        }
      })
      .then(async () => {
        await getCartProducts()
      })
      .catch(console.log)
  }
  const updateQuantity = async (supplyOrderProductId, quantity) => {
    try {
      await ctx.root.$apollo.mutate({
        mutation: gql`
          mutation updateSupplyOrderProduct($productId: Int!, $input: SupplyOrderProductUpdateInput!) {
            updateSupplyOrderProduct(supplyOrderProductId: $productId, input: $input)
          }
        `,
        variables: {
          productId: supplyOrderProductId,
          input: { quantity }
        }
      })
      ctx.root.$notify({ type: 'success', message: 'Quantidade alterada com sucess.' })
    } catch (err) {}
  }

  return {
    loading,
    supplyOrders,
    removeProduct,
    deleteSupplyOrder,
    updateQuantity,
    getCartProducts
  }
}



// WEBPACK FOOTER //
// ./src/composition/useCartProducts.js